import { render } from "./OfferCreate.vue?vue&type=template&id=97c5dda6&ts=true"
import script from "./OfferCreate.vue?vue&type=script&lang=ts"
export * from "./OfferCreate.vue?vue&type=script&lang=ts"

import "./OfferCreate.vue?vue&type=style&index=0&id=97c5dda6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__